var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('div',{staticClass:"home_wrapper fullwidth",attrs:{"id":"section_wrapper"}},[_c('hi-section',{ref:"intro"}),_c('featured-works',{ref:"featured"}),_c('me-section',{ref:"statement"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }